import {
  Box,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ListItem,
  useTheme,
} from "@mui/material";
import React from "react";
import { NavLink, Navigate, useLocation, useNavigate } from "react-router-dom";
import ArrowLeftSVG from "../../../../../../media/images/icons/arrow-left";
import { useAppSelector } from "../../../../../../hooks/useRedux";
import ArrowTickLeft from "../../../../../../media/images/icons/arrow-tick-left";
import ActiveListSVG from "../../../../../../media/images/icons/activelist-icon";

interface Props {
  type?: string;
  icon: JSX.Element;
  title: string;
  path?: string;
  handleClick?: () => void;
  /** When true, only runs handleClick on click - no navigation */
  actionOnly?: boolean;
}

export default function CustomListItem(props: Props) {
  const { icon, title, path = "", handleClick, type, actionOnly } = props;
  const theme = useTheme();

  const { pathname } = useLocation();

  const isActive = !actionOnly && pathname === path;

  const themeMode = useAppSelector((state) => state.settings.themeMode);

  const navigate = useNavigate();

  return (
    <ListItem
      className={isActive ? "CListItem" : ""}
      onClick={handleClick}
      sx={{
        "& .MuiButtonBase-root": {
          direction: "rtl",
          display: "flex",
          justifyContent: "space-between",
        },
        "& .MuiListItemButton-root": {
          padding: "4px 6px",
        },
        "& .MuiListItemIcon-root": {
          minWidth: 0,
        },
      }}
      disablePadding
    >
      <style>
        {`
        .CListItem  .MuiButtonBase-root:hover {
            background-color: ${theme.palette.primary.main} !important;
          }
          `}
      </style>
      <ListItemButton
        onClick={() => {
          if (actionOnly && handleClick) {
            handleClick();
          } else if (path) {
            navigate(path);
          }
        }}
        sx={{
          backgroundColor: isActive ? "primary.main" : "",
          borderRadius: "10px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
            fontWeight: "600",
          }}
        >
          {icon}
          <ListItemText
            primaryTypographyProps={{
              sx: {
                fontSize: "14px",
                color: isActive
                  ? "#fff"
                  : type === "exit"
                  ? "error.main"
                  : "textColor.main",
              },
            }}
            primary={title}
          />
        </Box>
        {type !== "exit" &&
          (isActive ? (
            <ListItemIcon>
              <ActiveListSVG
                color={
                  themeMode === "light" ? theme.palette.textColor.main : "#fff"
                }
                size={18}
              />
            </ListItemIcon>
          ) : (
            <ListItemIcon>
              <ArrowTickLeft
                color={
                  themeMode === "light" ? theme.palette.textColor.main : "#fff"
                }
                size={16}
              />
            </ListItemIcon>
          ))}
      </ListItemButton>
    </ListItem>
  );
}
